import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { failClosedAfterUnconfirmedOfflineCleanup } from '../utils/webClockSession';

/**
 * Returns a stable callback that resets the WebClock session and fail-closes
 * when offline secure-storage cleanup was not confirmed.
 *
 * @returns {() => void}
 */
export const useUnconfirmedSessionCleanup = () => {
  const dispatch = useDispatch();

  return useCallback(() => {
    failClosedAfterUnconfirmedOfflineCleanup({
      dispatch,
      error: new Error(
        'Offline secure storage was not cleared after session ended.'
      ),
    });
  }, [dispatch]);
};
